"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
require("@/components/common/dot/semantics/current-indicator");
const dot_styles_1 = require("@/components/common/dot/dot.styles");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * 페이지네이션 번호 버튼.
 * 아이콘 대신 페이지 번호 텍스트를 렌더링하고 현재 페이지 상태(aria-current)를 표현한다.
 */
let PageButton = class PageButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.page = 1;
        this.ariaCurrent = null;
        this.disabled = false;
        this.ariaLabel = '';
    }
    render() {
        return (0, lit_1.html) `
      <button
        type="button"
        aria-label=${this.ariaLabel || `${this.page} 페이지로 이동`}
        aria-current=${(0, if_defined_js_1.ifDefined)(this.ariaCurrent ?? undefined)}
        ?disabled=${this.disabled}
      >
        ${this.page} ${this.renderCurrentIndicator()}
      </button>
    `;
    }
    renderCurrentIndicator() {
        if (this.ariaCurrent !== 'page')
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-current-indicator></mm-current-indicator>
    `;
    }
};
PageButton.styles = [
    shared_styles_1.resetStyles,
    icon_button_styles_1.iconButtonStyles,
    (0, lit_1.css) `
      :host {
        ${(0, icon_button_styles_1.iconButtonVariantSkin)('ghost')}
      }

      button[aria-current='page'] {
        border-color: var(--interaction-selected-border-color);
        color: var(--interaction-selected-foreground-color);
        position: relative;
      }

      mm-current-indicator {
        ${dot_styles_1.dotBelowStyles};
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], PageButton.prototype, "page", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-current', reflect: true })
], PageButton.prototype, "ariaCurrent", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], PageButton.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], PageButton.prototype, "ariaLabel", void 0);
PageButton = __decorate([
    (0, decorators_js_1.customElement)('mm-page-button')
], PageButton);
exports.PageButton = PageButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFnZS1idXR0b24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwYWdlLWJ1dHRvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBb0Q7QUFDcEQscURBQTJEO0FBQzNELGdFQUF3RDtBQUl4RCwrREFBNEQ7QUFDNUQsbUVBQW1FO0FBQ25FLDJGQUcyRDtBQUMzRCwrREFBeUQ7QUFFekQ7OztHQUdHO0FBRUksSUFBTSxVQUFVLEdBQWhCLE1BQU0sVUFBVyxTQUFRLGdCQUFVO0lBQW5DOztRQW9CdUIsU0FBSSxHQUFHLENBQUMsQ0FBQTtRQUNrQyxnQkFBVyxHQUMvRSxJQUFJLENBQUE7UUFDdUIsYUFBUSxHQUFHLEtBQUssQ0FBQTtRQUNRLGNBQVMsR0FBRyxFQUFFLENBQUE7SUFzQnJFLENBQUM7SUFwQkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7OztxQkFHTSxJQUFJLENBQUMsU0FBUyxJQUFJLEdBQUcsSUFBSSxDQUFDLElBQUksVUFBVTt1QkFDdEMsSUFBQSx5QkFBUyxFQUFDLElBQUksQ0FBQyxXQUFXLElBQUksU0FBUyxDQUFDO29CQUMzQyxJQUFJLENBQUMsUUFBUTs7VUFFdkIsSUFBSSxDQUFDLElBQUksSUFBSSxJQUFJLENBQUMsc0JBQXNCLEVBQUU7O0tBRS9DLENBQUE7SUFDSCxDQUFDO0lBRU8sc0JBQXNCO1FBQzVCLElBQUksSUFBSSxDQUFDLFdBQVcsS0FBSyxNQUFNO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFL0MsT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUE1Q00saUJBQU0sR0FBRztJQUNkLDJCQUFXO0lBQ1gscUNBQWdCO0lBQ2hCLElBQUEsU0FBRyxFQUFBOztVQUVHLElBQUEsMENBQXFCLEVBQUMsT0FBTyxDQUFDOzs7Ozs7Ozs7O1VBVTlCLDJCQUFjOztLQUVuQjtDQUNGLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3dDQUFTO0FBQ2tDO0lBQXJFLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLGNBQWMsRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7K0NBQy9EO0FBQ3VCO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQzs0Q0FBaUI7QUFDUTtJQUFwRCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxZQUFZLEVBQUUsQ0FBQzs2Q0FBZTtBQXhCeEQsVUFBVTtJQUR0QixJQUFBLDZCQUFhLEVBQUMsZ0JBQWdCLENBQUM7R0FDbkIsVUFBVSxDQThDdEI7QUE5Q1ksZ0NBQVUifQ==